import type { RoleExtension as RoleExtensionModel } from '@/adapters/catalogv1.g';

export function extractRoleExtension(model: RoleExtensionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    roleRef: model.role_ref ?? '',
    permissionCount: model.role_permissions?.length ?? 0,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogRoleExtension = ReturnType<typeof extractRoleExtension>;
